<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field v-model="time" :label="inputLabel" prepend-icon="far fa-clock" readonly v-on="on" :rules="rules"></v-text-field>
    </template>
    <v-time-picker v-if="menu" v-model="time" full-width @click:minute="$refs.menu.save(time)"></v-time-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    label: String,
    rules: Array
  },
  data: () => ({
    menu: false,
    time: ''
  }),
  watch: {
    time (val) {
      this.$emit('input', val)
    }
  },
  computed: {
    inputLabel () {
      return this.label || 'Select Time'
    }
  }
}
</script>
